import {
  Affix as MantineAffix,
  AffixProps as MantineAffixProps,
} from '@mantine/core';

export type AffixProps = MantineAffixProps;

export const Affix = MantineAffix;

Affix.displayName = 'Affix';
